import { FunctionComponent, useState } from 'react';
import { Box, createStyles, makeStyles, Modal, Theme, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { Button } from 'components/UI';
import { wbp, reduceResolution } from 'Theme';
import clsx from 'clsx';
import { Prospect } from 'model/ProspectMessage';
import { formatPhoneNumberByLength } from '../utils';
import AddClient, { AddNewClient } from './AddNewClient';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

interface Props {
    prospect: Prospect;
    onSaveNewClient: () => void;
    onBackButton: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        chatHeaderContainer: {
            width: '100%',
            height: '8%',
            display: 'flex',
            [theme.breakpoints.down(wbp)]: {
                padding: `${reduceResolution(5)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                padding: '5px'
            },
            flexDirection: 'row',
            alignItems: 'center',
            borderBottom: '#D4D4D4 1px solid'
        },
        chatHeaderLeftContainer: {
            display: 'flex',
            width: '50%',
            flexDirection: 'row',
            alignItems: 'center'
        },
        chatHeaderRightContainer: {
            display: 'flex',
            width: '50%',
            flexDirection: 'row-reverse',
            alignItems: 'center'
        },
        chatHeaderTitle: {
            color: '#000',
            fontWeight: 600,
            [theme.breakpoints.down(wbp)]: {
                paddingLeft: `${reduceResolution(25)}px !important`,
                fontSize: `${reduceResolution(16)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingLeft: '25px !important',
                fontSize: '16px'
            }
        },
        chatHeaderItem: {
            cursor: 'pointer',
            [theme.breakpoints.down(wbp)]: {
                paddingRight: `${reduceResolution(15)}px`,
                paddingLeft: `${reduceResolution(15)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingRight: '15px',
                paddingLeft: '15px'
            }
        },
        chatBookNowButton: {
            [theme.breakpoints.down(wbp)]: {
                height: `${reduceResolution(37)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                height: '37px'
            }
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        backButton: {
            cursor: 'pointer',
            paddingLeft: '12px'
        }
    })
);

const ChatHeader: FunctionComponent<Props> = props => {
    const classes = useStyles();
    const [showAddClient, setShowAddClient] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box className={classes.chatHeaderContainer}>
            <Box className={classes.chatHeaderLeftContainer}>
                {isMobile && (
                    <FontAwesomeIcon
                        icon={faArrowLeft}
                        size="lg"
                        onClick={() => props.onBackButton && props.onBackButton()}
                        className={classes.backButton}
                    />
                )}
                <Typography className={clsx(classes.chatHeaderTitle, classes.chatHeaderItem)}>
                    {formatPhoneNumberByLength(props.prospect.phone) ?? ''}
                </Typography>
            </Box>
            <Box className={classes.chatHeaderRightContainer}>
                <Button
                    onClick={() => {
                        setShowAddClient(true);
                    }}
                    className={clsx(classes.chatBookNowButton, classes.chatHeaderItem)}
                    label="Add as Client"
                    color="orange"
                    size="medium"
                />
            </Box>
            {showAddClient && (
                <Modal
                    open={true}
                    aria-labelledby="simple-dialog-title"
                    className={classes.modal}
                >
                    <AddNewClient
                        prospect={props.prospect}
                        onSaveNewClient={props.onSaveNewClient}
                        onClose={() => setShowAddClient(false)}
                    />
                </Modal>
            )}
        </Box>
    );
};

export default ChatHeader;
